export default __webpack_public_path__ + "static/media/7.e0c2ea0d.png";